// Blushi-Skin Theme - Cart Drawer JavaScript
(function() {
  'use strict';

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartCloseButtons = document.querySelectorAll('[data-cart-drawer-close]');

  // Open cart drawer
  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  // Close cart drawer
  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Toggle cart drawer
  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (cartDrawer.classList.contains('is-open')) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
    });
  }

  // Close buttons
  cartCloseButtons.forEach(function(button) {
    button.addEventListener('click', closeCartDrawer);
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  // Format money helper
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Render cart item HTML
  function renderCartItem(item) {
    var imageHtml = item.image 
      ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="' + item.title + '" width="60" height="60" loading="lazy">'
      : '<div class="cart-drawer__item-placeholder">🌿</div>';
    
    var variantHtml = item.variant_title 
      ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
      : '';

    return '<div class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="cart-drawer__item-image">' + imageHtml + '</a>' +
      '<div class="cart-drawer__item-info">' +
        '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
        variantHtml +
        '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
      '</div>' +
      '<div class="cart-drawer__item-actions">' +
        '<div class="cart-drawer__item-quantity">' +
          '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-minus data-key="' + item.key + '">−</button>' +
          '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-plus data-key="' + item.key + '">+</button>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" width="16" height="16">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />' +
          '</svg>' +
        '</button>' +
      '</div>' +
    '</div>';
  }

  // Render empty cart HTML
  function renderEmptyCart() {
    return '<div class="cart-drawer__empty">' +
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" width="48" height="48">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />' +
      '</svg>' +
      '<p>Your cart is empty</p>' +
      '<a href="/collections/all" class="cart-drawer__continue">Continue Shopping</a>' +
    '</div>';
  }

  // Render footer HTML
  function renderFooter(cart) {
    return '<div class="cart-drawer__subtotal">' +
        '<span>Subtotal</span>' +
        '<span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="cart-drawer__shipping-note">Shipping calculated at checkout</p>' +
      '<a href="/checkout" class="cart-drawer__checkout button button--primary">Proceed to Checkout</a>' +
      '<a href="/cart" class="cart-drawer__view-cart">View Full Cart</a>';
  }

  // Update cart drawer content dynamically
  function updateCartDrawerContent(cart) {
    var bodyEl = document.querySelector('[data-cart-drawer-body]');
    var footerEl = document.querySelector('.cart-drawer__footer');
    
    if (!bodyEl) return;

    if (cart.item_count > 0) {
      // Render items
      var itemsHtml = '<div class="cart-drawer__items">';
      cart.items.forEach(function(item) {
        itemsHtml += renderCartItem(item);
      });
      itemsHtml += '</div>';
      bodyEl.innerHTML = itemsHtml;

      // Render or update footer
      if (footerEl) {
        footerEl.innerHTML = renderFooter(cart);
      } else {
        var contentEl = document.querySelector('.cart-drawer__content');
        if (contentEl) {
          var newFooter = document.createElement('div');
          newFooter.className = 'cart-drawer__footer';
          newFooter.innerHTML = renderFooter(cart);
          contentEl.appendChild(newFooter);
        }
      }

      // Rebind event listeners for new elements
      bindCartItemEvents();
    } else {
      bodyEl.innerHTML = renderEmptyCart();
      if (footerEl) {
        footerEl.remove();
      }
    }
  }

  // Update cart count in header
  function updateCartCount(count) {
    var countEl = document.querySelector('[data-cart-count]');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  // Refresh cart drawer content via AJAX
  function refreshCartDrawer() {
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        updateCartDrawerContent(cart);
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function(error) {
        console.error('Error refreshing cart:', error);
      });
  }

  // Update cart quantity
  function updateCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      updateCartDrawerContent(cart);
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  // Remove item
  function removeCartItem(key) {
    return updateCartItem(key, 0);
  }

  // Delegated events to prevent full page refresh and avoid re-binding
  function bindCartDrawerDelegatedEvents() {
    if (!cartDrawer) return;

    cartDrawer.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');

      var btn = removeBtn || minusBtn || plusBtn;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var key = btn.dataset.key;
      if (!key) return;

      if (removeBtn) {
        removeCartItem(key);
        return;
      }

      var itemEl = btn.closest('[data-cart-item]');
      var qtyEl = itemEl ? itemEl.querySelector('.cart-drawer__qty-value') : null;
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : NaN;
      if (!qtyEl || isNaN(qty)) {
        // Fallback: re-fetch cart and try again after DOM is in sync
        refreshCartDrawer();
        return;
      }

      if (minusBtn) {
        if (qty > 1) updateCartItem(key, qty - 1);
        else removeCartItem(key);
      }

      if (plusBtn) {
        updateCartItem(key, qty + 1);
      }
    });
  }

  // Initialize delegated events once
  bindCartDrawerDelegatedEvents();

  // Expose functions globally
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.refreshCartDrawer = refreshCartDrawer;

  // Refresh cart after add to cart success (without auto-opening drawer)
  window.afterAddToCart = function() {
    return refreshCartDrawer();
  };
})();
